import React from 'react'
import Util from './Util'
import Com from './Com.js'
import Timer from './Timer.js'
import MagicData from './MagicData.js'
import Audio from './Audio.js'
import Translations from './Translations.js'

let allowedRooms = []
let allowedRoomsNames = []
try {
	allowedRooms = JSON.parse(atob((new URLSearchParams(window.location.search)).get('rooms')))
	allowedRoomsNames = JSON.parse(atob((new URLSearchParams(window.location.search)).get('names')))
}
catch(ex) { }

let dialogMagicData = MagicData.newMagicData({type: 'welcome', title: 'Bienvenue !'})
let sessionAmountIncrementMagicData = MagicData.newMagicData(30*60)
let startSessionAutomaticallyMagicData = MagicData.newMagicData(false)
let rooms = {}
let currentForceUpdate = function() {}
let localeMagicData = MagicData.newMagicData('fr')

let initialized = false
function init() {
	initialized = true
	Com.connectMagicData(localeMagicData, '', 'locale')
	Com.connectMagicData(sessionAmountIncrementMagicData, '', 'sessionAmountIncrement', true)
	Com.connectMagicData(startSessionAutomaticallyMagicData, '', 'startSessionAutomatically', false)
	Com.childLeft = function(roomName) {
		if (allowedRooms.indexOf(roomName) === -1) return
		rooms[roomName].sessionTimerConfMagicData.setValue(null)
		rooms[roomName].sessionAmountMagicData.setValue(null)
		delete rooms[roomName]
		currentForceUpdate()
	}
	Com.newChildArrived = function(newRoomName) {
		if (allowedRooms.indexOf(newRoomName) === -1) return
		let room = {
			sessionAmountMagicData: MagicData.newMagicData(),
			sessionTimerConfMagicData: MagicData.newMagicData(),
			sessionTimerPositionMagicData: MagicData.newMagicData(),
			assistanceTimerConfMagicData: MagicData.newMagicData(),
			assistanceTimerPositionMagicData: MagicData.newMagicData(),
			assistanceTypeMagicData: MagicData.newMagicData()
		}

		room.assistanceTypeMagicData.addChangeCb(function(newValue) {
			let welcomeDialogIsThere = dialogMagicData.getValue() && dialogMagicData.getValue().type === 'welcome'
			if (newValue && !welcomeDialogIsThere) Audio.playSingle(newValue === 'bar'?'call':'call_double')
		})

		room.sessionTimerConfMagicData.addChangeCb(function(newValue) {
			let welcomeDialogIsThere = dialogMagicData.getValue() && dialogMagicData.getValue().type === 'welcome'
			if (!newValue && !welcomeDialogIsThere) Audio.playSingle('end')
		})

		Timer.newTimer(room.sessionTimerConfMagicData, room.sessionTimerPositionMagicData)
		Timer.newTimer(room.assistanceTimerConfMagicData, room.assistanceTimerPositionMagicData)
		Com.connectMagicData(room.sessionAmountMagicData, newRoomName, 'sessionAmount')
		Com.connectMagicData(room.sessionTimerConfMagicData, newRoomName, 'sessionTimerConf')
		Com.connectMagicData(room.assistanceTimerConfMagicData, newRoomName, 'assistanceTimerConf')
		Com.connectMagicData(room.assistanceTypeMagicData, newRoomName, 'assistanceType')
		rooms[newRoomName] = room
		currentForceUpdate()
	}
	for (let roomName in Com.theData.children) {
		Com.newChildArrived(roomName)
	}
}

function ManageCentralLegacy() {

	if (!initialized) init()

	const [ignored, forceUpdate] = React.useReducer(x => x + 1, 0)
	currentForceUpdate = forceUpdate

	const [dialog, setDialog] = React.useState(dialogMagicData.getValue())
	dialogMagicData.addChangeCb(setDialog)
	const [sessionAmountIncrement, setSessionAmountIncrement] = React.useState(sessionAmountIncrementMagicData.getValue())
	const [startSessionAutomatically, setStartSessionAutomatically] = React.useState(startSessionAutomaticallyMagicData.getValue())
	sessionAmountIncrementMagicData.addChangeCb(setSessionAmountIncrement)
	startSessionAutomaticallyMagicData.addChangeCb(setStartSessionAutomatically)

	const [sessionAmount1, setSessionAmount1] = React.useState(null)
	const [sessionTimerConf1, setSessionTimerConf1] = React.useState(null)
	const [sessionTimerPosition1, setSessionTimerPosition1] = React.useState(null)
	const [assistanceTimerPosition1, setAssistanceTimerPosition1] = React.useState(null)
	const [assistanceType1, setAssistanceType1] = React.useState(null)

	const [sessionAmount2, setSessionAmount2] = React.useState(null)
	const [sessionTimerConf2, setSessionTimerConf2] = React.useState(null)
	const [sessionTimerPosition2, setSessionTimerPosition2] = React.useState(null)
	const [assistanceTimerPosition2, setAssistanceTimerPosition2] = React.useState(null)
	const [assistanceType2, setAssistanceType2] = React.useState(null)

	const [sessionAmount3, setSessionAmount3] = React.useState(null)
	const [sessionTimerConf3, setSessionTimerConf3] = React.useState(null)
	const [sessionTimerPosition3, setSessionTimerPosition3] = React.useState(null)
	const [assistanceTimerPosition3, setAssistanceTimerPosition3] = React.useState(null)
	const [assistanceType3, setAssistanceType3] = React.useState(null)

	const [sessionAmount4, setSessionAmount4] = React.useState(null)
	const [sessionTimerConf4, setSessionTimerConf4] = React.useState(null)
	const [sessionTimerPosition4, setSessionTimerPosition4] = React.useState(null)
	const [assistanceTimerPosition4, setAssistanceTimerPosition4] = React.useState(null)
	const [assistanceType4, setAssistanceType4] = React.useState(null)

	const [sessionAmount5, setSessionAmount5] = React.useState(null)
	const [sessionTimerConf5, setSessionTimerConf5] = React.useState(null)
	const [sessionTimerPosition5, setSessionTimerPosition5] = React.useState(null)
	const [assistanceTimerPosition5, setAssistanceTimerPosition5] = React.useState(null)
	const [assistanceType5, setAssistanceType5] = React.useState(null)

	const [sessionAmount6, setSessionAmount6] = React.useState(null)
	const [sessionTimerConf6, setSessionTimerConf6] = React.useState(null)
	const [sessionTimerPosition6, setSessionTimerPosition6] = React.useState(null)
	const [assistanceTimerPosition6, setAssistanceTimerPosition6] = React.useState(null)
	const [assistanceType6, setAssistanceType6] = React.useState(null)

	const [locale, setLocale] = React.useState(localeMagicData.getValue())

	// fonction translations
	function _(aText) {
		if (!Translations[locale]) return aText
		if (!Translations[locale][aText]) return aText
		return Translations[locale][aText]
	}

	localeMagicData.addChangeCb(setLocale)

	for (let roomName in rooms) {
		let room = rooms[roomName]
		if (roomName === allowedRooms[0]) {
			room.sessionAmount = sessionAmount1
			room.setSessionAmount = setSessionAmount1
			room.sessionTimerConf = sessionTimerConf1
			room.setSessionTimerConf = setSessionTimerConf1
			room.sessionTimerPosition = sessionTimerPosition1
			room.setSessionTimerPosition = setSessionTimerPosition1
			room.assistanceTimerPosition = assistanceTimerPosition1
			room.setAssistanceTimerPosition = setAssistanceTimerPosition1
			room.assistanceType = assistanceType1
			room.setAssistanceType = setAssistanceType1
		}
		else if (roomName === allowedRooms[1]) {
			room.sessionAmount = sessionAmount2
			room.setSessionAmount = setSessionAmount2
			room.sessionTimerConf = sessionTimerConf2
			room.setSessionTimerConf = setSessionTimerConf2
			room.sessionTimerPosition = sessionTimerPosition2
			room.setSessionTimerPosition = setSessionTimerPosition2
			room.assistanceTimerPosition = assistanceTimerPosition2
			room.setAssistanceTimerPosition = setAssistanceTimerPosition2
			room.assistanceType = assistanceType2
			room.setAssistanceType = setAssistanceType2
		}
		else if (roomName === allowedRooms[2]) {
			room.sessionAmount = sessionAmount3
			room.setSessionAmount = setSessionAmount3
			room.sessionTimerConf = sessionTimerConf3
			room.setSessionTimerConf = setSessionTimerConf3
			room.sessionTimerPosition = sessionTimerPosition3
			room.setSessionTimerPosition = setSessionTimerPosition3
			room.assistanceTimerPosition = assistanceTimerPosition3
			room.setAssistanceTimerPosition = setAssistanceTimerPosition3
			room.assistanceType = assistanceType3
			room.setAssistanceType = setAssistanceType3
		}
		else if (roomName === allowedRooms[3]) {
			room.sessionAmount = sessionAmount4
			room.setSessionAmount = setSessionAmount4
			room.sessionTimerConf = sessionTimerConf4
			room.setSessionTimerConf = setSessionTimerConf4
			room.sessionTimerPosition = sessionTimerPosition4
			room.setSessionTimerPosition = setSessionTimerPosition4
			room.assistanceTimerPosition = assistanceTimerPosition4
			room.setAssistanceTimerPosition = setAssistanceTimerPosition4
			room.assistanceType = assistanceType4
			room.setAssistanceType = setAssistanceType4
		}
		else if (roomName === allowedRooms[4]) {
			room.sessionAmount = sessionAmount5
			room.setSessionAmount = setSessionAmount5
			room.sessionTimerConf = sessionTimerConf5
			room.setSessionTimerConf = setSessionTimerConf5
			room.sessionTimerPosition = sessionTimerPosition5
			room.setSessionTimerPosition = setSessionTimerPosition5
			room.assistanceTimerPosition = assistanceTimerPosition5
			room.setAssistanceTimerPosition = setAssistanceTimerPosition5
			room.assistanceType = assistanceType5
			room.setAssistanceType = setAssistanceType5
		}
		else if (roomName === allowedRooms[5]) {
			room.sessionAmount = sessionAmount6
			room.setSessionAmount = setSessionAmount6
			room.sessionTimerConf = sessionTimerConf6
			room.setSessionTimerConf = setSessionTimerConf6
			room.sessionTimerPosition = sessionTimerPosition6
			room.setSessionTimerPosition = setSessionTimerPosition6
			room.assistanceTimerPosition = assistanceTimerPosition6
			room.setAssistanceTimerPosition = setAssistanceTimerPosition6
			room.assistanceType = assistanceType6
			room.setAssistanceType = setAssistanceType6
		}
		else continue
		room.sessionAmountMagicData.addChangeCb(room.setSessionAmount)
		room.sessionTimerConfMagicData.addChangeCb(room.setSessionTimerConf)
		room.sessionTimerPositionMagicData.addChangeCb(room.setSessionTimerPosition)
		room.assistanceTimerPositionMagicData.addChangeCb(room.setAssistanceTimerPosition)
		room.assistanceTypeMagicData.addChangeCb(room.setAssistanceType)
	}

	for (let roomName in rooms) {
		let room = rooms[roomName]
		let session = ''
		if (room.sessionAmount === null) session = _('Démarrage...')
		else if (room.sessionAmount === 0) session = _('Aucune session')
		else if (room.sessionAmount-room.sessionTimerPosition <= 0) session = _('Bientôt fini')+' / '+Util.formatDurationMSOrHMS(room.sessionAmount)
		else if (room.sessionTimerPosition === null) session = _('Attente')+' / '+Util.formatDurationMSOrHMS(room.sessionAmount)
		else session = Util.formatDurationMSOrHMS(room.sessionAmount-room.sessionTimerPosition)+' / '+Util.formatDurationMSOrHMS(room.sessionAmount)
		room.session = session
	}

	//let roomNamesList = Object.keys(rooms)
	//roomNamesList.sort()
	let roomNamesList = []
	for (let roomName of allowedRooms) {
		if (rooms[roomName]) roomNamesList.push(roomName)
	}

	let tilesHeight = roomNamesList.length
	let tilesWidth = 1+1
	return (
		<div style={{width: '1080px', height: '1920px', background: 'black', color: 'white', fontFamily: 'Adobe Caslon Pro Regular', fontSize: '30px', textAlign: 'center'}}>

			{/* Dialog background */}
			<div
				hidden={!dialog}
				style={{position: 'absolute', zIndex: '1001', width: '1080px', height: '1920px', background: 'rgba(0, 0, 0, .85)'}}
				onClick={function() {
					dialogMagicData.setValue(null)
				}}
			></div>

			{/* Dialogs */}
			<div style={{position: 'relative'}}>
				{dialog &&
					<div style={{position: 'absolute', left: '210px', top: '240px', zIndex: '1002', textAlign: 'left'}}>
						<img
							src='images/icon_clear.png'
							style={{float: 'right'}}
							onClick={function() {
								dialogMagicData.setValue(null)
							}}
						/>
						<div style={{clear: 'both'}}></div>
						<div className='borderBlue' style={{background: 'black', width: '600px', height: '300px', padding: '15px 25px 15px 25px', borderRadius: '7px'}}>
							<div style={{textAlign: 'right'}}>
								<span className="open25">{dialog.title}</span>
							</div>
							{dialog.type === 'roomMenu' &&
								<div style={{margin: 'auto', width: '405px', paddingTop: '100px', background: 'transparent', textAlign: 'center'}}>
									<div
										style={{float: 'left', paddingLeft: '80px', background: 'transparent', textAlign: 'center', display: 'none'}}
										onClick={function() {
											dialogMagicData.setValue(null)
											Com.setVariable(dialog.roomName, 'system', 'restart')
										}}
									>
										<img src='images/icon_restart.png'/>
										<div style={{textAlign: 'center'}}>
											<span className="open25">{_("Redémarrer")}</span>
										</div>
									</div>
									<div
										style={{float: 'left', paddingLeft: '80px', background: 'transparent', textAlign: 'center'}}
										onClick={function() {
											dialogMagicData.setValue(null)
											Com.setVariable(dialog.roomName, 'system', 'shutdown')
										}}
									>
										<img src='images/icon_shutdown.png'/>
										<div style={{textAlign: 'center'}}>
											<span className="open25">{_("Éteindre")}</span>
										</div>
									</div>
									<div style={{clear: 'both'}}></div>
								</div>
							}
							{dialog.type === 'welcome' &&
								<div style={{margin: 'auto', width: '405px', paddingTop: '50px', background: 'transparent', textAlign: 'center'}}>
									<div className="open25" style={{textAlign: 'center'}}>
									{_("AntalZic vous souhaite la Bienvenue !" )}
									</div>
									<div
										style={{paddingTop: '40px', textAlign: 'center'}}
										onClick={function() {
											dialogMagicData.setValue(null)
										}}
									>
										<img src='images/icon_rocket.png'/>
										<div style={{textAlign: 'center'}}>
											<span className="open25">{_("C'est parti !")}</span>
										</div>
									</div>
									<div style={{clear: 'both'}}></div>
								</div>
							}
						</div>
					</div>
				}
			</div>

			<img src='images/back1.png' style={{position: 'absolute', left: '0px', top: '0px', zIndex: '999', pointerEvents: 'none', width: '1080px', height: '1920px', objectFit: 'fill', opacity: '0.3', mixBlendMode: 'screen'}} />
			<div style={{padding: '70px 70px 0px 70px'}}></div>
			<div style={{background: `url(images/karaworld${locale === 'es' ? '_es' : locale === 'en' ? '_en' : ''}.png)`, width: '1080px', height: '180px', margin: 'auto'}}></div>
			<div style={{padding: '50px 70px 0px 70px'}}>
				{Array.apply(0, Array(tilesWidth*tilesHeight)).map(function(num, i) {
					let x = Math.floor(i/tilesWidth)
					let y = i%tilesWidth
					if (y === tilesWidth-1) return (
						<div key={i} style={{clear: 'both'}}></div>
					)
					else {
						let roomName = roomNamesList[x]
						let roomName2 = allowedRoomsNames[allowedRooms.indexOf(roomName)]
						let room = rooms[roomName]
						let bar = room.assistanceType === 'bar'
						let help = room.assistanceType === 'help'
						let isSession = room.sessionAmount > 0
						if (help || bar) return (
							<div
								key={i}
								className={Math.round(room.assistanceTimerPosition*2)%2 === 0?'borderBlack':(help?'borderRed':'borderBlue')}
								style={{float: 'left', marginTop: x>0?'20px':'0px', marginLeft: '0px', width: '908px', height: '86px', background: 'transparent', padding: '16px 11px 16px 11px', borderRadius: '7px', textAlign: 'center'}}
								onClick={function() {
									//room.assistanceTimerConfMagicData.setValue(null)
									//room.assistanceTypeMagicData.setValue(null)
									Com.setVariable(roomName, 'assistanceTimerConf', null)
									Com.setVariable(roomName, 'assistanceType', null)
								}}
							>
								<div className='center' style={{paddingTop: '6px', paddingLeft: '15px', paddingRight: '15px'}}>
									<div style={{background: 'transparent', float: 'left', width: '170px', height: '64px', fontFamily: 'Open Sans Condensed Light', fontSize: '55px', lineHeight: '57px', textAlign: 'left'}}>
										{/*Salle {(y*tilesHeight+x+1)}*/}
										{roomName2}
									</div>
									<div style={{background: 'transparent', float: 'left', width: '435px', height: '64px', fontFamily: 'Open Sans Condensed Light', fontSize: '55px', lineHeight: '57px', textAlign: 'center'}}>
										{help?'Assistance':'Appel bar'}
									</div>
									<div style={{background: 'transparent', float: 'left', width: '100px', height: '64px'}}>
										{bar && <img src='images/icon_bar.png'/>}
										{help && <img src='images/icon_help.png'/>}
									</div>
									<div style={{background: 'transparent', float: 'left', width: '173px', height: '64px', fontFamily: 'Open Sans Condensed Light', fontSize: '55px', lineHeight: '57px', textAlign: 'right'}}>
										{Util.formatDurationMSOrHMS(room.assistanceTimerPosition)}
									</div>
									<div style={{clear: 'both'}}></div>
								</div>
							</div>
						)
						else return (
							<div
								key={i}
								className={isSession?'borderGreen':''}
								style={{float: 'left', marginTop: x>0?'20px':'0px', marginLeft: '0px', width: '908px', height: '86px', background: isSession?'transparent':'#303030', padding: isSession?'16px 11px 16px 11px':'21px 16px 21px 16px', borderRadius: '7px', textAlign: 'center'}}
							>
								<div className='center' style={{paddingTop: '6px', paddingLeft: '15px', paddingRight: '15px'}}>
									<div style={{background: 'transparent', float: 'left', width: '170px', height: '64px', fontFamily: 'Open Sans Condensed Light', fontSize: '55px', lineHeight: '57px', textAlign: 'left'}}>
										{/*Salle {(y*tilesHeight+x+1)}*/}
										{roomName2}
									</div>
									<div style={{background: 'transparent', float: 'left', width: '435px', height: '64px', fontFamily: 'Open Sans Condensed Light', fontSize: '55px', lineHeight: '57px', textAlign: 'center'}}>
										{/*{y*tilesHeight+x+1 === 1 ? session : 'Déconnectée'}*/}
										{room.session}
									</div>
									<div style={{background: 'transparent', float: 'left', width: '165px', height: '64px'}}>
										{room.sessionAmount !== null && <img src='images/icon_time.png' onClick={function() {
											let newAmount = prompt("Nombre de minutes ?")
											if (newAmount === '') return
											newAmount = parseInt(newAmount)
											if (isNaN(newAmount)) return
											newAmount = newAmount*60
											//if (newAmount === 0) newAmount = 1
											Com.setVariable(roomName, 'sessionAmount', newAmount)
										}}/>}
										{/*room.sessionAmount !== null && <img src='images/icon_more_time.png' onClick={function() {
											let newAmount = parseInt(room.sessionAmount)+parseInt(sessionAmountIncrement)
											//room.sessionAmountMagicData.setValue(newAmount)
											Com.setVariable(roomName, 'sessionAmount', newAmount)
											if (startSessionAutomatically && newAmount > 0 && room.sessionTimerConf === null) {
												setTimeout(function() {
													Com.setVariable(roomName, 'sessionTimerConf', [Date.now(), room.sessionTimerPosition, newAmount, 1])
												}, 1000)
											}
										}}/>}
										{room.sessionAmount !== null && <img src='images/icon_less_time.png' onClick={function() {
											let newAmount = Math.max(parseInt(room.sessionAmount)-parseInt(sessionAmountIncrement), 0)
											if (newAmount <= room.sessionTimerPosition) newAmount = 0
											//room.sessionAmountMagicData.setValue(newAmount)
											Com.setVariable(roomName, 'sessionAmount', newAmount)
											if (startSessionAutomatically && newAmount > 0 && room.sessionTimerConf === null) {
												setTimeout(function() {
													Com.setVariable(roomName, 'sessionTimerConf', [Date.now(), room.sessionTimerPosition, newAmount, 1])
												}, 1000)
											}
										}} style={{paddingLeft: '10px'}}/>*/}
									</div>
									<div style={{background: 'transparent', float: 'left', width: '108px', height: '64px', textAlign: 'right'}}>
										<img
											src='images/icon_menu.png'
											onClick={function() {
												dialogMagicData.setValue({type: 'roomMenu', roomName: roomName, title: roomName2})
											}}
										/>
									</div>
									<div style={{clear: 'both'}}></div>
								</div>
							</div>
						)
					}
				})}
			</div>

		</div>
	)
}

export default ManageCentralLegacy
